﻿import axios from 'config/axios';

export default class BranchService {
  static async get(branchId) {
    const { data } = await axios.get(`branches/${branchId}/`);
    return data;
  }
}
